import { initialFormState } from "../../../StepShipping/reducer.js";
const seedFieldState = (key, value) => {
  return {
    name: key,
    value,
    isValid: false,
    isTouched: true
  };
};
const seedFormData = (fields, formValues) => {
  return fields.reduce((formData, fieldName) => {
    const fieldValue = formValues[fieldName];
    return {
      ...formData,
      // If source data does not have the field name, do not initialise the formState,
      // since the form inputs will initialise already with their own initialState
      ...fieldValue ? {
        [fieldName]: seedFieldState(fieldName, fieldValue)
      } : {}
    };
  }, {});
};
const seedInitialFormState = (fields) => {
  const formState = {
    formData: {}
  };
  fields.forEach((fieldName) => {
    formState.formData[fieldName] = {
      name: fieldName,
      value: "",
      isValid: false,
      isTouched: false
    };
  });
  return formState;
};
const seedShippingForm = (fields, formValues, form) => {
  const formData = {
    ...form?.formData,
    ...seedFormData(fields, formValues)
  };
  return Object.keys(formData).length ? {
    ...form || initialFormState,
    formData: {
      ...form?.formData,
      ...seedFormData(fields, formValues)
    }
  } : void 0;
};
export {
  seedFieldState,
  seedInitialFormState,
  seedShippingForm
};
//# sourceMappingURL=seed-shipping-form.js.map
